import { _mock } from "./_mock";

export const _blockingList = [...Array(20)].map((_, index) => ({
  id: Math.floor(Math.random() * 1000),

  name: _mock.firstName(index) + " " + _mock.lastName(index),

  providerId: Math.floor(Math.random() * 1000),
  eventId: Math.floor(Math.random() * 1000),
  venueId: Math.floor(Math.random() * 4),
  slotId: Math.floor(Math.random() * 1000),

  startDate: _mock.time(index),
  endDate: _mock.time(index),
  description: _mock.description(index),
  view: Math.floor(Math.random() * 2) % 2 == 1 ? true : false,

  status: (index % 2 && 0) || (index % 3 && 1) || 1,
}));
